import React from "react";

export const ModalFormRight = ({  
    id,
    title,
    data,
    children 
}) => {

    return (
        <>
            <div
                className="offcanvas offcanvas-end"
                tabIndex="-1"
                id="offcanvasRightComponent"
                aria-labelledby={`${id}Label`}
                data-bs-backdrop="false"
                data-bs-scroll="true"
            >
                <div className="offcanvas-header">
                    <h5
                        id={`${id}Label`}
                        style={{
                            fontWeight: "bold",
                        }}
                    >
                        {title}
                    </h5>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        style={{ backgroundColor: "aliceblue" }}
                    />
                </div>
                <div className="offcanvas-body">
                   {children}
                </div>
            </div>

        </>
    );
}